import { useEffect, useRef, useState } from 'react';
import api from '../../api/api';
import { createEditorRecommendations } from './editorRecommendations';
import { normalizeSimilarArtist } from '../artist/artistPresentation';
const unwrap = (response) => response.data?.data ?? response.data;
const read = (path, signal) =>
  api.getPublic(path, { signal, suppressGlobalError: true, timeout: 15000 }).then(unwrap);
export const editorRecommendationTransport = {
  readArtist: async (artist, signal) => {
    const data = await read(
      `/artists?id=${encodeURIComponent(artist.sourceId)}&type=${artist.artistSource?.toLowerCase() === 'spotify' ? 'spotify' : 'apple_music'}`,
      signal,
    );
    return {
      ...data,
      similarArtists: {
        ...data.similarArtists,
        items: (data.similarArtists?.items || []).map(normalizeSimilarArtist),
      },
    };
  },
  searchArtists: (name, signal) =>
    read(`/search/artists/all?q=${encodeURIComponent(name)}`, signal),
  searchTracks: (name, signal) =>
    read(`/search/tracks?q=${encodeURIComponent(name)}&page=1&size=20`, signal),
};
export default function useEditorRecommendations({ items, results, type }) {
  const selected = useRef(items);
  selected.current = items;
  const [state, setState] = useState({ children: {}, loading: new Set(), errors: new Set() });
  const engine = useRef(null);
  if (!engine.current)
    engine.current = createEditorRecommendations({
      getSelected: () => selected.current,
      onChange: setState,
      ...editorRecommendationTransport,
    });
  useEffect(() => {
    engine.current.reset(type, results || []);
  }, [type, results]);
  useEffect(() => () => engine.current.dispose(), []);
  return { ...state, load: engine.current.load };
}
